import { useInt } from 'hooks/useInt';

import { NumberedFeatureCards } from 'ui/organisms/NumberedFeatureCards/NumberedFeatureCards';
import { NumberedStatsSection } from 'ui/organisms/NumberedStatsSection/NumberedStatsSection';
import { AccessRoutes } from 'ui/organisms/AccessRoutes/AccessRoutes';

import { InsuranceAccumulation } from 'landing-pages/insurance/sections/InsuranceAccumulation/InsuranceAccumulation';
import { InsuranceCitation } from 'landing-pages/insurance/sections/InsuranceCitation/InsuranceCitation';
import { InsuranceClosing } from 'landing-pages/insurance/sections/InsuranceClosing/InsuranceClosing';
import { InsuranceHero } from 'landing-pages/insurance/sections/InsuranceHero/InsuranceHero';
import { InsuranceMonitoring } from 'landing-pages/insurance/sections/InsuranceMonitoring/InsuranceMonitoring';
import { InsuranceComparison } from 'landing-pages/insurance/sections/InsuranceComparison/InsuranceComparison';
import { InsuranceProvenance } from 'landing-pages/insurance/sections/InsuranceProvenance/InsuranceProvenance';
import { InsuranceRegistries } from 'landing-pages/insurance/sections/InsuranceRegistries/InsuranceRegistries';
import { InsuranceSanctions } from 'landing-pages/insurance/sections/InsuranceSanctions/InsuranceSanctions';
import { InsuranceVendorReview } from 'landing-pages/insurance/sections/InsuranceVendorReview/InsuranceVendorReview';

import styles from './InsurancePage.module.scss';

import {
  getAccessRoutes,
  getInsuranceDeskItems,
  getInsuranceLeakageRows,
  getInsuranceLeakageStats,
} from './InsurancePage.data';

export const InsurancePage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <InsuranceHero />
      <NumberedStatsSection
        title={t('The risk you priced and the company that exists are two different records.')}
        description={t(
          'A submission is written by the party who benefits from the answer. A filing is made under statutory obligation and dated. Five places that gap becomes loss.',
        )}
        rows={getInsuranceLeakageRows(t)}
        stats={getInsuranceLeakageStats(t)}
        footnote={t(
          'Provisional figures. Method note published alongside before launch. Median 94 days between a material filing and the next scheduled renewal review.',
        )}
      />
      <InsuranceAccumulation />
      <InsuranceSanctions />
      <NumberedFeatureCards
        theme="light"
        title={t('Six desks reading one source of record.')}
        items={getInsuranceDeskItems(t)}
        columns={3}
      />
      <InsuranceMonitoring />
      <InsuranceCitation />
      <InsuranceProvenance />
      <InsuranceRegistries />
      <InsuranceComparison />
      <InsuranceVendorReview />
      <AccessRoutes
        background="light"
        introCard
        heading={t('How to access the data.')}
        lede={t('Seven routes into the same primary, government-sourced dataset. Pick the one that fits your stack.')}
        routes={getAccessRoutes(t)}
      />
      <InsuranceClosing />
    </div>
  );
};
